import { ThingModelType } from '@/pages/gateway/ProductManage/types';
import { CommonResponse, TableReponseType } from '@/types';
import { httpRequest } from '@/utils/request';

export function addThingModel(data: any) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/thingmodel',
    method: 'post',
    data,
  });
}
export function putThingModel(data: any) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/thingmodel',
    method: 'put',
    data,
  });
}

export function deleteThingModel(data: { thing_model_id: string; thing_model_type: string }) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/thingmodel',
    method: 'delete',
    data,
  });
}

export function thingModelSystem<T>(params: { modelName: string; thingModelType?: ThingModelType }) {
  return httpRequest<any, CommonResponse<T>>({
    url: '/api/v1/thingmodel/system',
    params,
  });
}

export function thingModelUnit<T>(params: { isAll: boolean }) {
  return httpRequest<any, CommonResponse<TableReponseType<T>>>({
    url: '/api/v1/thingmodel/unit',
    params,
  });
}

export function thingModelExport<T>(params: { product_id: string }) {
  return httpRequest<any, CommonResponse<T>>({
    url: `/api/v1/thingmodel/export/${params.product_id}`,
    method: 'post',
  });
}

export function thingModelImport<T>(data: { product_id: string; data: string }) {
  return httpRequest<any, CommonResponse<T>>({
    url: `/api/v1/thingmodel/import/${data.product_id}`,
    method: 'post',
    data,
  });
}

export function copyThingModel<T>(data: {
  copy_to_product_id: string;
  copy_from_product_id: string;
  thing_mode_copy_info: Array<{
    thing_model_id: string;
    thing_model_type: 'properties' | 'events' | 'actions';
  }>;
}) {
  return httpRequest<any, CommonResponse<T>>({
    url: '/api/v1/thingmodel/copy',
    method: 'post',
    data,
  });
}